var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{attrs:{"text":"Status Change","variant":"outline-dark","disabled":_vm.isLoading}},_vm._l((_vm.statuses),function(status){return _c('b-dropdown-item',{key:status,on:{"click":function($event){return _vm.updateOrderStatus(status)}}},[_vm._v("\n      "+_vm._s(_vm.translateStatus(status))+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }